import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomePage from "./pages/HomePage";
import Header from "./components/Header";
import Footer from "./components/Footer";
// import FormManagement from './pages/FormManagement';
import AboutUs from "./pages/AboutUs";
// import HowItWorks from './pages/HowItWorks';
// import WhyAC from './pages/WhyAC';
import Cookie from "./pages/Cookie";
import Terms from "./pages/Terms";
import Policy from "./pages/Policy";
// import VideoReviews from './pages/VideoReviews';
// import RomanceScam from './pages/RomanceScam';
// import InvoiceScam from './pages/InvoiceScam';
// import CryptoScam from './pages/CryptoScam';
// import SafeAccountScam from './pages/SafeAccountScam';
// import InvestmentScam from './pages/InvestmentScam';
// import JobTaskScam from './pages/JobTaskScam';
// import PurchaseScam from './pages/PurchaseScam';
// import UnauthorisedScam from './pages/UnauthorisedScam';
// import SkilledWorkerEmploymentVisas from './pages/SkilledWorkerEmploymentVisas';
// import StudyPermitsGraduatePathways from './pages/StudyPermitsGraduatePathways';
// import FamilyDependentVisas from './pages/FamilyDependentVisas';
// import PermanentResidenceCitizenship from './pages/PermanentResidenceCitizenship';
// import InvestorEntrepreneurVisas from './pages/InvestorEntrepreneurVisas';
// import VisitorShortStay from './pages/VisitorShortStay';
// import AppealsComplexCases from './pages/AppealsComplexCases';
// import UnitedStates from './pages/UnitedStates';
// import Canada from './pages/Canada';
// import UnitedKingdom from './pages/UnitedKingdom';
// import GermanyEU from './pages/GermanyEU';
// import Australia from './pages/Australia';
// import UAE from './pages/UAE';
import Contact from "./pages/Contact";
import AlzheimersDementiaCare from "./pages/AlzheimersDementiaCare";
import CompanionshipCare from "./pages/CompanionshipCare";
import HospiceCare from "./pages/HospiceCare";
import PersonalCare from "./pages/PersonalCare";
import PostOperativeCare from "./pages/PostOperativeCare";
import RespiteCare from "./pages/RespiteCare";
import SpecialtyCare from "./pages/SpecialtyCare";
import SpinalCordInjuryCare from "./pages/SpinalCordInjuryCare";
import FAQ from "./pages/FAQ";
import MeetTheTeam from "./pages/MeetTheTeam";
import ReviewsTestimonials from "./pages/ReviewsTestimonials";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import InvoicePayments from "./pages/InvoicePayments";
import ManageInvoices from "./pages/ManageInvoices";
import NotFound from "./pages/NotFound";
import Careers from "./pages/Careers";
import HealthcareAssistantJob from "./pages/jobs/HealthcareAssistantJob";
import PhysiotherapistJob from "./pages/jobs/PhysiotherapistJob";
import DriverJob from "./pages/jobs/DriverJob";
import JobApplicationForm from "./pages/jobs/JobApplicationForm";
import AdminDashboard from "./pages/admin/AdminDashboard";
import ManageContracts from "./pages/admin/ManageContracts";
import ContractSubmissionPage from "./pages/ContractSubmissionPage";

const App = () => {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        {/* <Route path="/start-claim" element={<StartClaim />} />  */}
        <Route path="/about" element={<AboutUs />} />
        {/* <Route path="/how-it-works" element={<HowItWorks />} />  */}
        {/* <Route path="/why-us" element={<WhyAC />} />  */}
        <Route path="/terms-of-service" element={<Terms />} />
        <Route path="/privacy-policy" element={<Policy />} />
        <Route path="/cookie-policy" element={<Cookie />} />
        {/* <Route path="/reviews" element={<VideoReviews />} />  */}
        {/* <Route path="/scams/romance" element={<RomanceScam />} />  */}
        {/* <Route path="/scams/invoice" element={<InvoiceScam />} />  */}
        {/* <Route path="/scams/investment" element={<InvestmentScam />} />  */}
        {/* <Route path="/scams/crypto" element={<CryptoScam />} />  */}
        {/* <Route path="/scams/safe" element={<SafeAccountScam />} />  */}
        {/* <Route path="/scams/purchase" element={<PurchaseScam />} />  */}
        {/* <Route path="/scams/job" element={<JobTaskScam />} />  */}
        {/* <Route path="/scams/unauthorised" element={<UnauthorisedScam />} />  */}
        {/* <Route path="/services/skilled-worker-employment" element={<SkilledWorkerEmploymentVisas />} /> */}
        {/* <Route path="/services/skilled-worker-employment-visas" element={<SkilledWorkerEmploymentVisas />} /> */}
        {/* <Route path="/services/study-permits-graduate-pathways" element={<StudyPermitsGraduatePathways />} /> */}
        {/* <Route path="/services/family-and-dependent-visas" element={<FamilyDependentVisas />} /> */}
        {/* <Route path="/services/permanent-residence-and-citizenship" element={<PermanentResidenceCitizenship />} /> */}
        {/* <Route path="/services/investor-and-entrepreneur-routes" element={<InvestorEntrepreneurVisas />} /> */}
        {/* <Route path="/services/visitor-and-short-stay" element={<VisitorShortStay />} /> */}
        {/* <Route path="/services/appeals-and-complex-cases" element={<AppealsComplexCases />} /> */}
        {/* <Route path="/countries/united-states" element={<UnitedStates />} /> */}
        {/* <Route path="/countries/canada" element={<Canada />} /> */}
        {/* <Route path="/countries/united-kingdom" element={<UnitedKingdom />} /> */}
        {/* <Route path="/countries/germany-eu" element={<GermanyEU />} /> */}
        {/* <Route path="/countries/australia" element={<Australia />} /> */}
        {/* <Route path="/countries/uae" element={<UAE />} /> */}
        <Route path="/contact" element={<Contact />} />
        <Route
          path="/services/alzheimers-dementia-care"
          element={<AlzheimersDementiaCare />}
        />
        <Route
          path="/services/companionship-care"
          element={<CompanionshipCare />}
        />
        <Route path="/services/hospice-care" element={<HospiceCare />} />
        <Route path="/services/personal-care" element={<PersonalCare />} />
        <Route
          path="/services/post-operative-care"
          element={<PostOperativeCare />}
        />
        <Route path="/services/respite-care" element={<RespiteCare />} />
        <Route path="/services/specialty-care" element={<SpecialtyCare />} />
        <Route
          path="/services/spinal-cord-injury-care"
          element={<SpinalCordInjuryCare />}
        />
        <Route path="/about/faq" element={<FAQ />} />
        <Route path="/about/meet-the-team" element={<MeetTheTeam />} />
        <Route
          path="/about/reviews-testimonials"
          element={<ReviewsTestimonials />}
        />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/invoice/payments" element={<InvoicePayments />} />
        <Route path="/invoice/manage" element={<ManageInvoices />} />
        <Route path="/careers" element={<Careers />} />
        <Route
          path="/jobs/healthcare-assistant"
          element={<HealthcareAssistantJob />}
        />
        <Route
          path="/jobs/healthcare-assistant/apply"
          element={<JobApplicationForm />}
        />
        <Route path="/jobs/physiotherapist" element={<PhysiotherapistJob />} />
        <Route
          path="/jobs/physiotherapist/apply"
          element={<JobApplicationForm />}
        />
        <Route path="/jobs/driver" element={<DriverJob />} />
        <Route path="/jobs/driver/apply" element={<JobApplicationForm />} />
        <Route path="/submit-contract" element={<ContractSubmissionPage />} />
        <Route path="/admin/applications" element={<AdminDashboard />} />
        <Route path="/admin/contracts" element={<ManageContracts />} />
        {/* <Route path="/forms/jndfe8939434ndfd" element={<FormManagement />} /> */}

        {/* Catch-all route for 404 pages */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;

// import React from 'react';
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import HomePage from './pages/HomePage';
// import Header from './components/Header';
// import Footer from './components/Footer';
// // import FormManagement from './pages/FormManagement';
// import AboutUs from './pages/AboutUs';
// // import HowItWorks from './pages/HowItWorks';
// // import WhyAC from './pages/WhyAC';
// import Cookie from './pages/Cookie';
// import Terms from './pages/Terms';
// import Policy from './pages/Policy';
// // import VideoReviews from './pages/VideoReviews';
// // import RomanceScam from './pages/RomanceScam';
// // import InvoiceScam from './pages/InvoiceScam';
// // import CryptoScam from './pages/CryptoScam';
// // import SafeAccountScam from './pages/SafeAccountScam';
// // import InvestmentScam from './pages/InvestmentScam';
// // import JobTaskScam from './pages/JobTaskScam';
// // import PurchaseScam from './pages/PurchaseScam';
// // import UnauthorisedScam from './pages/UnauthorisedScam';
// // import SkilledWorkerEmploymentVisas from './pages/SkilledWorkerEmploymentVisas';
// // import StudyPermitsGraduatePathways from './pages/StudyPermitsGraduatePathways';
// // import FamilyDependentVisas from './pages/FamilyDependentVisas';
// // import PermanentResidenceCitizenship from './pages/PermanentResidenceCitizenship';
// // import InvestorEntrepreneurVisas from './pages/InvestorEntrepreneurVisas';
// // import VisitorShortStay from './pages/VisitorShortStay';
// // import AppealsComplexCases from './pages/AppealsComplexCases';
// // import UnitedStates from './pages/UnitedStates';
// // import Canada from './pages/Canada';
// // import UnitedKingdom from './pages/UnitedKingdom';
// // import GermanyEU from './pages/GermanyEU';
// // import Australia from './pages/Australia';
// // import UAE from './pages/UAE';
// import Contact from './pages/Contact';
// import AlzheimersDementiaCare from './pages/AlzheimersDementiaCare';
// import CompanionshipCare from './pages/CompanionshipCare';
// import HospiceCare from './pages/HospiceCare';
// import PersonalCare from './pages/PersonalCare';
// import PostOperativeCare from './pages/PostOperativeCare';
// import RespiteCare from './pages/RespiteCare';
// import SpecialtyCare from './pages/SpecialtyCare';
// import SpinalCordInjuryCare from './pages/SpinalCordInjuryCare';
// import FAQ from './pages/FAQ';
// import MeetTheTeam from './pages/MeetTheTeam';
// import ReviewsTestimonials from './pages/ReviewsTestimonials';
// import PrivacyPolicy from './pages/PrivacyPolicy';
// import InvoicePayments from './pages/InvoicePayments';
// import ManageInvoices from './pages/ManageInvoices';
// import NotFound from './pages/NotFound';
// import Careers from './pages/Careers';
// import JobApplicationForm from './pages/jobs/JobApplicationForm';
// import AdminDashboard from './pages/admin/AdminDashboard';
// import ManageContracts from './pages/admin/ManageContracts';
// import ContractSubmissionPage from './pages/ContractSubmissionPage';

// const App = () => {
//   return (
//     <Router>
//       <Header />
//       <Routes>
//         <Route path="/" element={<HomePage />} />
//         {/* <Route path="/start-claim" element={<StartClaim />} />  */}
//         <Route path="/about" element={<AboutUs />} />
//         {/* <Route path="/how-it-works" element={<HowItWorks />} />  */}
//         {/* <Route path="/why-us" element={<WhyAC />} />  */}
//         <Route path="/terms-of-service" element={<Terms />} />
//         <Route path="/privacy-policy" element={<Policy />} />
//         <Route path="/cookie-policy" element={<Cookie />} />
//         {/* <Route path="/reviews" element={<VideoReviews />} />  */}
//         {/* <Route path="/scams/romance" element={<RomanceScam />} />  */}
//         {/* <Route path="/scams/invoice" element={<InvoiceScam />} />  */}
//         {/* <Route path="/scams/investment" element={<InvestmentScam />} />  */}
//         {/* <Route path="/scams/crypto" element={<CryptoScam />} />  */}
//         {/* <Route path="/scams/safe" element={<SafeAccountScam />} />  */}
//         {/* <Route path="/scams/purchase" element={<PurchaseScam />} />  */}
//         {/* <Route path="/scams/job" element={<JobTaskScam />} />  */}
//         {/* <Route path="/scams/unauthorised" element={<UnauthorisedScam />} />  */}
//         {/* <Route path="/services/skilled-worker-employment" element={<SkilledWorkerEmploymentVisas />} /> */}
//         {/* <Route path="/services/skilled-worker-employment-visas" element={<SkilledWorkerEmploymentVisas />} /> */}
//         {/* <Route path="/services/study-permits-graduate-pathways" element={<StudyPermitsGraduatePathways />} /> */}
//         {/* <Route path="/services/family-and-dependent-visas" element={<FamilyDependentVisas />} /> */}
//         {/* <Route path="/services/permanent-residence-and-citizenship" element={<PermanentResidenceCitizenship />} /> */}
//         {/* <Route path="/services/investor-and-entrepreneur-routes" element={<InvestorEntrepreneurVisas />} /> */}
//         {/* <Route path="/services/visitor-and-short-stay" element={<VisitorShortStay />} /> */}
//         {/* <Route path="/services/appeals-and-complex-cases" element={<AppealsComplexCases />} /> */}
//         {/* <Route path="/countries/united-states" element={<UnitedStates />} /> */}
//         {/* <Route path="/countries/canada" element={<Canada />} /> */}
//         {/* <Route path="/countries/united-kingdom" element={<UnitedKingdom />} /> */}
//         {/* <Route path="/countries/germany-eu" element={<GermanyEU />} /> */}
//         {/* <Route path="/countries/australia" element={<Australia />} /> */}
//         {/* <Route path="/countries/uae" element={<UAE />} /> */}
//         <Route path="/contact" element={<Contact />} />
//         <Route path="/services/alzheimers-dementia-care" element={<AlzheimersDementiaCare />} />
//         <Route path="/services/companionship-care" element={<CompanionshipCare />} />
//         <Route path="/services/hospice-care" element={<HospiceCare />} />
//         <Route path="/services/personal-care" element={<PersonalCare />} />
//         <Route path="/services/post-operative-care" element={<PostOperativeCare />} />
//         <Route path="/services/respite-care" element={<RespiteCare />} />
//         <Route path="/services/specialty-care" element={<SpecialtyCare />} />
//         <Route path="/services/spinal-cord-injury-care" element={<SpinalCordInjuryCare />} />
//         <Route path="/about/faq" element={<FAQ />} />
//         <Route path="/about/meet-the-team" element={<MeetTheTeam />} />
//         <Route path="/about/reviews-testimonials" element={<ReviewsTestimonials />} />
//         <Route path="/privacy-policy" element={<PrivacyPolicy />} />
//         <Route path="/invoice/payments" element={<InvoicePayments />} />
//         <Route path="/invoice/manage" element={<ManageInvoices />} />
//         <Route path="/careers" element={<Careers />} />
//         <Route path="/jobs/healthcare-assistant" element={<JobApplicationForm />} />
//         <Route path="/jobs/physiotherapist" element={<JobApplicationForm />} />
//         <Route path="/jobs/driver" element={<JobApplicationForm />} />
//         <Route path="/submit-contract" element={<ContractSubmissionPage />} />
//         <Route path="/admin/applications" element={<AdminDashboard />} />
//         <Route path="/admin/contracts" element={<ManageContracts />} />
//         {/* <Route path="/forms/jndfe8939434ndfd" element={<FormManagement />} /> */}

//         {/* Catch-all route for 404 pages */}
//         <Route path="*" element={<NotFound />} />
//       </Routes>
//       <Footer />
//     </Router>
//   );
// };

// export default App;
